


































































































































import { Component, Vue } from 'vue-property-decorator';
import { trainServer, dictServe, institutionServer } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import dayjs from 'dayjs';
import { TableStripe } from '@/mixins/tableStripe';
import publishObjectPath from '@/util/configRegistry';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class AddDialog extends Vue {
  private visible = false;
  private title = '';
  private formData: any = {
    endTime: '',
    preparedTraineeNum: 1,
    remark: '',
    startTime: '',
    trainAddress: '',
    trainCategory: '',
    trainContent: '',
    trainDay: null,
    trainTimeUnit: '',
    trainMethod: '',
    trainName: '',
    trainUnitId: '',
    trainUnitName: '',
    trainUnitType: '',
    traineeTarget: '',
  };

  ruleFrom: any = {
    trainCategory: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
    trainName: [{ required: true, message: '请输入培训名称', trigger: 'blur' }],
    startTime: [{ required: true, message: '请选择起止时间', trigger: 'blur' }],
    trainUnitName: [{ required: true, message: '请输入培训单位', trigger: 'blur' }],
    trainMethod: [{ required: true, message: '请选择培训方式', trigger: 'blur' }],
    traineeTarget: [{ required: true, message: '请选择培训对象', trigger: 'blur' }],
    trainDay: [{ required: true, message: '请选择培训学时', trigger: 'blur' }],
  };

  private date: any = '';
  private trainUnitList: any = [
    {
      label: '小时',
      value: '小时',
    },
    {
      label: '天',
      value: '天',
    },
    {
      label: '月',
      value: '月',
    },
    {
      label: '年',
      value: '年',
    },
  ]; // 学时单位
  subSpaceByAuthOptions: any = []; // 单位
  trainCategoryOptions: any = []; //培训类别
  trainMethods: any = []; //培训方式

  trainRecords: any = []; // 详情返回的培训记录
  activeName: any = '';

  private canEdit = false;
  private actionUrl: any = '';
  private headers: any = {};
  private serverUrl = publishObjectPath.imgPathWater;
  mounted() {
    this.actionUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile/annex';
    this.headers.Authorization = localStorage.getItem('token');
  }
  private handleClick(tab: any, event: any, id?: any) {
    console.log(tab, event);
  }

  private handlePreview(file: any) {
    console.log(file, '2334');
    const urlPath: any = this.serverUrl + file.path;
    this.getBlob(urlPath).then((blob: any) => {
      this.saveAs(blob, file.name);
    });
  }
  getBlob = (url: any) => {
    return new Promise((resolve: any) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        if (xhr.status == 200) {
          resolve(xhr.response);
        }
      };
      xhr.send();
    });
  };
  saveAs = (blob: any, name: any) => {
    const url = window.URL.createObjectURL(blob);
    const aLink = document.createElement('a');
    aLink.style.display = 'none';
    aLink.href = url;
    aLink.setAttribute('download', name);
    document.body.appendChild(aLink);
    aLink.click();
    document.body.removeChild(aLink); // 下载完成移除元素
    window.URL.revokeObjectURL(url); // 释放掉blob对象
  };

  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getAllData({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  // 获取培训方式 培训类别
  getDictData(name: any) {
    dictServe.getDetailsMapByName(name).then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            value: key,
            label: res.data[key],
          });
        }
        if (name === 'train_category') {
          this.trainCategoryOptions = helpArr;
        } else if (name === 'train_method') {
          this.trainMethods = helpArr;
        }
      } else {
        this.$message.warning('获取数据失败！');
      }
    });
  }

  showDialog(data: any) {
    this.getSubSpaceByAuth();
    this.getDictData('train_category');
    this.getDictData('train_method');
    switch (data.type) {
      case 'add':
        this.title = '添加';
        this.canEdit = false;
        this.formData.preparedTraineeNum = 1;
        break;
      case 'edit':
        this.title = '编辑';
        this.getData(data.data);
        this.canEdit = false;
        break;
      case 'detail':
        this.title = '详情';
        this.canEdit = true;
        this.getData(data.data);
        break;
    }
    this.visible = true;
  }

  // 选择时间
  changeTime(time: any) {
    this.formData.startTime =
      dayjs(time[0])
        .startOf('month')
        .format('YYYY-MM-DD') +
      ' ' +
      '00:00:00';
    this.formData.endTime =
      dayjs(time[1])
        .endOf('month')
        .format('YYYY-MM-DD') +
      ' ' +
      '23:59:59';
  }

  getData(id: any) {
    trainServer.infoTrainRequestData(id).then((res: any) => {
      if (res.code === '200') {
        this.formData.id = res.data.id;
        this.formData.endTime = res.data.endTime;
        this.formData.preparedTraineeNum = res.data.preparedTraineeNum;
        this.formData.remark = res.data.remark;
        this.formData.startTime = res.data.startTime;
        this.formData.trainAddress = res.data.trainAddress;
        this.formData.trainCategory = res.data.trainCategory;
        this.formData.trainContent = res.data.trainContent;
        this.formData.trainDay = res.data.trainDay;
        this.formData.trainTimeUnit = res.data.trainTimeUnit;
        this.formData.trainMethod = res.data.trainMethod;
        this.formData.trainName = res.data.trainName;
        this.formData.trainUnitId = res.data.trainUnitId;
        this.formData.trainUnitName = res.data.trainUnitName;
        this.formData.trainUnitType = res.data.trainUnitType;
        this.formData.traineeTarget = res.data.traineeTarget;
        this.trainRecords = res.data.trainRecords;
        if (res.data.trainRecords.length > 0) {
          this.activeName = res.data.trainRecords[0].id;
        }
        if (res.data.startTime) {
          this.date = [dayjs(res.data.startTime).format('YYYY-MM-DD'), dayjs(res.data.endTime).format('YYYY-MM-DD')];
        }
      }
    });
  }

  hideDialog() {
    this.visible = false;
    this.formData = {
      endTime: '',
      preparedTraineeNum: 1,
      remark: '',
      startTime: '',
      trainAddress: '',
      trainCategory: '',
      trainContent: '',
      trainDay: null,
      trainTimeUnit: '',
      trainMethod: '',
      trainName: '',
      trainUnitId: '',
      trainUnitName: '',
      trainUnitType: '',
      traineeTarget: '',
    };
    this.date = '';
    (this.$refs.formData as any).resetFields(); // 重置表单内容
    // this.$nextTick(() => {
    //   (this.$refs.form as any).clearValidate();
    // });
    this.$emit('getTableData');
  }

  submitForm() {
    if (parseFloat(this.formData.trainDay) >= 9999) {
      return this.$message.error('培训天数不能大于9999天');
    }
    //表单验证
    const formComponent: any = this.$refs['formData'];
    formComponent.validate(async (valid: any) => {
      if (!valid) return;
      if (this.title === '添加') {
        this.addFunction();
      } else {
        this.editFunction();
      }
    });
  }
  addFunction() {
    trainServer.trainRequestAdd(this.formData).then((res: any) => {
      if (res.code == 200) {
        this.$message.success('添加成功');
        this.hideDialog();
      } else {
        this.$message.error(res.msg);
      }
    });
  }
  editFunction() {
    trainServer.trainRequestEdit(this.formData.id, this.formData).then((res: any) => {
      if (res.code == 200) {
        this.$message.success('编辑成功');
        this.hideDialog();
      } else {
        this.$message.error(res.msg);
      }
    });
  }
}
